import React from "react";
import PropTypes from "prop-types";
import GenericCard from "components/UI/GenericCard/GenericCard";
import { returnUpDownClassname } from "utils/helpers";

const ReturnDistributionCard = (props) => {
  const { metrics } = props.optionsResults;

  return (
    <GenericCard
      title="Return at window end"
      tooltipText="Underlying's return at maxDays regardless of whether the target was hit along the way."
    >
      <div className="flex gap-8">
        <div>
          <h5>Avg</h5>
          <h3 className={returnUpDownClassname(metrics.avgFinalReturn)}>
            {metrics.avgFinalReturn}%
          </h3>
        </div>
        <div>
          <h5>Median</h5>
          <h3 className={returnUpDownClassname(metrics.medianFinalReturn)}>
            {metrics.medianFinalReturn}%
          </h3>
        </div>
        <div>
          <h5>Std dev</h5>
          <h3>{metrics.stdDevFinalReturn}%</h3>
        </div>
      </div>
      <div className="pt-2">
        <h5>All signals -- percentiles (p5/p25/p50/p75/p95)</h5>
        <h4>
          {metrics.finalReturnPercentiles.p5}% /{" "}
          {metrics.finalReturnPercentiles.p25}% /{" "}
          {metrics.finalReturnPercentiles.p50}% /{" "}
          {metrics.finalReturnPercentiles.p75}% /{" "}
          {metrics.finalReturnPercentiles.p95}%
        </h4>
      </div>
      <div className="pt-2">
        <h5>Wins only -- percentiles (p25/p50/p75/p95)</h5>
        <h4 className="green">
          {metrics.winReturnPercentiles.p25}% /{" "}
          {metrics.winReturnPercentiles.p50}% /{" "}
          {metrics.winReturnPercentiles.p75}% /{" "}
          {metrics.winReturnPercentiles.p95}%
        </h4>
      </div>
    </GenericCard>
  );
};

ReturnDistributionCard.propTypes = { optionsResults: PropTypes.object };

export default ReturnDistributionCard;
